module.exports = __webpack_public_path__ + "img/google_icon.80ebb9c0.png";